// import COMPANY_API from '@/api/masterData/company.js';

export const formFields = (ctx) => {
  return [
    // {
    //   prop: 'statementCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   valueType: 'object',
    //   method: 'post',
    // },
    // {
    //   prop: 'statementDepartmentNo',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.baseFormData.statementCompanyNo,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: ctx.baseFormData.statementCompanyNo == '',
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   changeMethod: 'changeDepartmentHandler',
    //   method: 'post',
    //   valueType: 'object',
    // },
    // {
    //   name: '客户名称',
    //   prop: 'customerName',
    //   type: 'searchTableSpec',
    //   searchType: 'sapCustomer',
    //   isMultiple: true,
    //   changeMethod: ctx.changeCustomsMethod,
    // },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'input',
    // },
    {
      prop: 'businessCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      disabled: true,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      // disabled: ctx.query?.businessCompanyNo == '',
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
      disabled: true,
    },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'searchTableSpec',
    //   searchType: 'contract',
    //   extraData: {
    //     contractCategory: 'sales',
    //     companyCode: ctx.query.businessCompanyNo,
    //     departmentCode: ctx.query.businessDepartmentCode,
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeContractMethod,
    //   currentValue: ctx.query?.contractNo,
    // },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '商品名称',
      prop: 'productName',
      type: 'input',
      disabled: true,
    },
    {
      name: '供应商名称',
      prop: 'supplierNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.query.businessCompanyNo,
        departmentCode: ctx.query.businessDepartmentCode,
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
      },
      isMultiple: true,
      changeMethod: ctx.changeSupplyChainMethod,
      currentValue: ctx.query?.supplierName,
      disabled: true,
    },
    // {
    //   name: '客户名称',
    //   prop: 'customerName',
    //   type: 'searchTableSpec',
    //   searchType: 'partner',
    //   extraData: {
    //     companyCode: ctx.baseFormData.businessCompanyNo,
    //     departmentCode: ctx.baseFormData.businessDepartmentCode,
    //     partnerTypes: 'HZHB01',
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeCustomsMethod,
    //   currentValue: ctx.baseFormData?.customerName,
    //   // disabled: !ctx.isCreate,
    //   disabled: true,
    // },
    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      disabled: true,
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
    },
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
    {
      prop: 'expenseType',
      name: '费用类型',
      type: 'select',
      options: ctx.dictListMap?.expenseType || [],
    },

    {
      name: '应付账期',
      prop: 'accountPeriod',
      type: 'date',
      format: 'yyyy-MM',
    },
    {
      // 申请日期从
      name: '业务结算日期从',
      prop: 'periodDateFrom',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '业务结算日期至',
      prop: 'periodDateUntil',
      type: 'endDaterangePicker',
    },

    {
      name: '车辆号',
      prop: 'vehicleNo',
      type: 'input',
    },
    {
      name: '项目编码',
      prop: 'projectInitiationNoLike',
      type: 'input',
    },
    {
      name: '项目简称',
      prop: 'projectNameLike',
      type: 'input',
    },
    {
      name: '基地名称',
      prop: 'baseNameLike',
      type: 'input',
    },
    {
      name: '费用编号',
      prop: 'expenseNoLike',
      type: 'input',
    },
    {
      // 申请日期从
      name: '业务日期从',
      prop: 'businessDateStart',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '业务日期至',
      prop: 'businessDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '原币结算金额(含税)',
      prop: ['originalTotalAmountStart', 'originalTotalAmountEnd'],
      type: 'inputRange',
      precision: 2, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
    },
    {
      name: '付款状态',
      prop: 'paymentStatus',
      type: 'select',
      options: [
        {
          label: '已付款',
          value: '01',
        },
        {
          label: '未付款',
          value: '02',
        },
        {
          label: '部分付款',
          value: '03',
        },
      ],
    },
    // {
    //   name: '锁定状态',
    //   prop: 'isLock',
    //   type: 'select',
    //   disabled: true,
    //   options: [
    //     {
    //       label: '未锁定',
    //       value: '0',
    //     },
    //     {
    //       label: '锁定',
    //       value: '1',
    //     },
    //   ],
    // },
    {
      prop: 'salesmanNo',
      name: '业务员',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changeSalesmanNoMethod,
    },
  ];
};

export const tableColumnList = [
  // {
  //   type: 'checkbox',
  //   visible: true,
  //   width: '50',
  //   fixed: 'left',
  // },
  // {
  //   type: 'seq',
  //   title: '序号',
  //   visible: true,
  //   width: '80',
  // },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
  },
  {
    field: 'supplierName',
    title: '供应商名称',
    visible: true,
    width: '150',
  },
  {
    field: 'isIndividualPartner',
    title: '个人合作伙伴',
    visible: true,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'accountPeriod',
    title: '应付账期',
    visible: true,
    width: '150',
  },
  {
    field: 'projectInitiationNo',
    title: '项目编号',
    visible: true,
    width: '150',
  },
  {
    field: 'projectName',
    title: '项目简称',
    visible: true,
    width: '150',
  },
  {
    field: 'baseName',
    title: '基地名称',
    visible: true,
    width: '150',
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
    visible: true,
  },
  {
    field: 'originalPrice',
    title: '结算单价(含税)',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unit',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },

  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },
  {
    field: 'paymentStatus',
    title: '付款状态',
    visible: true,
  },
  // {
  //   field: 'isLock',
  //   title: '锁定状态',
  //   visible: true,
  // },
  {
    field: 'paidAmount',
    title: '已付款金额(原币)',
    visible: true,
  },

  {
    field: 'unpaidAmount',
    title: '未付款金额(原币)',
    visible: true,
  },
  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
    visible: true,
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
    visible: true,
  },
  {
    field: 'expenseNo',
    title: '费用编号',
    visible: true,
  },
  {
    field: 'businessDate',
    title: '业务日期',
    visible: true,
  },
  {
    field: 'taxRate',
    title: '税率',
    visible: true,
  },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'businessDocCode',
    title: '业务单据编码',
    visible: true,
  },
  // {
  //   field: 'inboundDate',
  //   title: '入库日期',
  //   visible: true,
  // },
  {
    field: 'productName',
    title: '商品名称',
    visible: true,
  },
  {
    field: 'goodsCategoryName',
    title: '商品类别',
    visible: true,
  },
  {
    field: 'vehicleNo',
    title: '车辆号',
    visible: true,
  },
  // {
  //   field: 'delivererName',
  //   title: '投送人',
  //   visible: true,
  // },
  {
    field: 'salesmanName',
    title: '业务员',
    visible: true,
  },
  {
    field: 'productModel',
    title: '规格',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '结算单编号',
    visible: true,
  },
  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
];
